import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fc7fd742"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc7fd742')) {
      api.createRecord('fc7fd742', component.options)
    } else {
      api.reload('fc7fd742', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fc7fd742", function () {
      api.rerender('fc7fd742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/distributor/index.vue"
export default component.exports